import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Stable vs variable APR',
  shortTitle: 'Variable APR',
  graphDotStable: 'Stable',
  graphDotVariable: 'Variable',
});
